// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"11d5cde5","705":"11d5cde5"}[chunkId] + ".chunk.css";
};